export const companyId = (company) => company?.companyId ?? company?.id ?? company?.value;

export function inactiveYear(company) {
  const value = company?.inactiveSince;
  if (value == null || value === "") return null;
  const year = Number(value);
  return Number.isInteger(year) && year >= 1000 && year <= 9999 ? year : null;
}

export function companyColor(type) {
  return {
    Parent: "#2b3384",
    Level_1_Company: "#e6700f",
    Level_2_Company: "#f28c38",
    Level_3_Company: "#c57228",
    Facilities: "#368b3b",
    Facility: "#368b3b",
  }[type] || "#2b3384";
}

export function inactiveNodeStyle(company) {
  if (inactiveYear(company) === null) return undefined;
  const color = companyColor(company.type || company.companyType);
  return { background: "white", color, border: `2px dashed ${color}` };
}

export function companiesForYear(companies = [], year, mode) {
  if (mode !== "COMPANY" || !year) return companies;
  const byId = new Map(companies.map((c) => [String(companyId(c)), c]));
  const closed = new Set(companies.filter((c) => {
    const since = inactiveYear(c);
    return since !== null && Number(year) >= since;
  }).map((c) => String(companyId(c))));
  return companies.filter((c) => {
    // Paths include ancestors outside the immediately rendered subtree.
    if (String(c.level || "").split("/").some((id) => closed.has(id))) return false;
    let current = c;
    const visited = new Set();
    while (current && !visited.has(String(companyId(current)))) {
      const id = String(companyId(current));
      if (closed.has(id)) return false;
      visited.add(id);
      current = byId.get(String(current.parentId));
    }
    return true;
  });
}

export function descendantsOf(companies, target) {
  const targetId = String(companyId(target));
  const byId = new Map(companies.map((c) => [String(companyId(c)), c]));
  return companies.filter((company) => {
    if (String(companyId(company)) === targetId) return false;
    if (target.level && String(company.level || "").startsWith(`${target.level}/`)) return true;
    let parentId = company.parentId;
    const visited = new Set();
    while (parentId != null && !visited.has(String(parentId))) {
      if (String(parentId) === targetId) return true;
      visited.add(String(parentId));
      parentId = byId.get(String(parentId))?.parentId;
    }
    return false;
  });
}

export function operatingStatusRequest(status, year, applyTo, hasChildren) {
  if (!["Active", "Inactive"].includes(status)) throw new Error("Invalid operating status");
  const body = { status };
  if (status === "Inactive") {
    if (!/^\d{4}$/.test(String(year)) || inactiveYear({ inactiveSince: year }) === null) {
      throw new Error("Enter a 4-digit year (1000–9999)");
    }
    body.inactiveSince = Number(year);
  }
  const allowed = status === "Inactive"
    ? ["self_and_descendants", "descendants_only"]
    : ["self_only", "self_and_descendants"];
  if (hasChildren) {
    if (!allowed.includes(applyTo)) throw new Error("Invalid apply-to option");
    body.applyTo = applyTo;
  }
  return body;
}
